/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { ReactNode } from 'react';
import type { SnippetsSectionProps } from '../Snippets/types';
import { CKBOX_URL } from '@ckeditor/ckeditor5-metadata';
import { HighlightCode } from '../../HighlightCode/HighlightCode';
import { SkeletonLoader } from '../SkeletonLoader/SkeletonLoader';
import { SnippetsSection } from '../Snippets/SnippetsSection';
import { Text } from './Text';
import { SECTION_NAME_ADD_CKBOX } from '../../../constants/snippetsSectionNames';

export function NpmSetupWithCkbox( { number, onCopyEvent, isLoading }: SnippetsSectionProps ): ReactNode {
	return (
		<SkeletonLoader number={ number } sectionTitle={ SECTION_NAME_ADD_CKBOX } isLoading={ isLoading }>
			<SnippetsSection headerCharacter={ number } title={ SECTION_NAME_ADD_CKBOX }>
				<Text>
					Since you have picked the CKBox feature, you need to add another script tag to your HTML to load it from CDN.
				</Text>
				<HighlightCode onCopyEvent={ onCopyEvent } lang={ 'html' } id={ 'setup-npm-ckbox' }>
					{ `<script src="${ CKBOX_URL }" crossorigin></script>` }
				</HighlightCode>
			</SnippetsSection>
		</SkeletonLoader>
	);
}
